import styled from "styled-components";
import { useGlobalContext } from "../context";
import { useState, useEffect } from "react";

const BookingWidget = () => {
  const { language } = useGlobalContext();

  const [popupStatus, setPopupStatus] = useState({
    dates: false,
    guests: false,
  });

  // Ascolta i messaggi provenienti dall'iframe
  useEffect(() => {
    const handleMessage = (event) => {
      if (event.data && event.data.type === "popup") {
        // console.log("Event", event.data);
        setPopupStatus((prev) => {
          return { ...prev, [event.data.name]: event.data.isVisible };
        });
      }
    };

    window.addEventListener("message", handleMessage);

    // Cleanup al dismount
    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, []);

  return (
    <Wrapper
      title="booking-iframe"
      style={{
        height: `${popupStatus.dates || popupStatus.guests ? "100vh" : "70px"}`,
        background: "transparent",
      }}
      //  height: '350px'

      srcDoc={`
          <html>
           
     <link href="https://aws-cdn.hbb.bz/illeonedimare_foot.css" rel="stylesheet" type="text/css" />
    
        
        <head>
  
        </head>
        <body>
        <style>

        .hbb_button_prenota {
          background: #1978BE !important;
          }
          input[type="button"].guest-sel-button {
            background-color: #1978BE !important;
            }
            .migliortariffa2 {
            font-family: "Open Sans", sans-serif !important;
            // font-weight: lighter !important;
            background: #1978BE !important;
            }
            .datepick-month a.dp-departure {
              background-color: #1978BE  !important
              }
              // .datepick-month .dp-arriva {
                //     background-color: #1978BE  !important
                // }
                .datepick-month .dp-arrival {
                  background-color: #1978BE  !important
                  }
                  .datepick-month .dp-in-range {
                    background: #1978BE !important;
                    }
                    .circle-button:hover {
                        background: #1978BE !important;
                    }
                    .hbb_button_prenota:hover {
                        background: #1978BE !important;
                    }
                    .datepick-popup:before {
                      border-bottom: 10px solid #1978BE !important; 
                      }
                      </style>
                                    
                  <div class="CHMASK" style="left:0px;margin:0 auto;  z-index: 999; bottom:0px; position:fixed;width:100%;">
                      <section  class="bookingengine--air app-booking-engine nascondidiv bookingengine" data-prefix="app-home">
                        <div  style="width:100%;" class="app-search-box-wrapper home-be__city">
                        <a style="text-decoration:none !important;" target="_blank" href="https://illeonedimare.hbb.bz/booking.php?lang=${language}&ID=MTMzNi1mNDE2NzE&step=1"><div class="migliortariffa2"> </div></a></div>
                      </section>
                    <script type="text/javascript" src="https://illeonedimare.hbb.bz/masks/includeMask.php?ID=MTMzNi1mNDE2NzE&lang=${language}&maskType=rfm&extType=j&modal=true"></script>
                    <div  class="bookByHBB"><a id="linkbb" style="color: #ccc; text-decoration: none;" title="hotel.bb, booking-engine" href="https://www.hotel.bb/booking-engine.php" target="_blank">Booking online by Hotel.BB</a></div></div>
                    <script> jQuery(document).ready(function(){jQuery(".migliortariffa2").html(jQuery(".hbb_button_prenota").val()); })</script>
                    </body>
                   
                    <script>
                  
                      function onVisibilityChange(selector, callback) {
                        let lastKnownState = false;

                        const checkVisibility = () => {
                            const element = document.querySelector(selector);
                            const isVisible = !!element && getComputedStyle(element).display !== "none";

                            if (isVisible !== lastKnownState) {
                                lastKnownState = isVisible;
                                callback(isVisible, element, selector);
                            }
                        };

                        const observer = new MutationObserver(() => checkVisibility());
                        observer.observe(document.body, { childList: true, subtree: true, attributes: true });

                        checkVisibility();

                        return observer;
                      }

                      document.addEventListener('DOMContentLoaded', () => {

                        onVisibilityChange(".select-guests-configurator", (isVisible, _, selector) => {
                            // console.log('Selector:', selector, isVisible);
                            window.parent.postMessage({ type: 'popup', name: 'guests', isVisible }, '*');
                        });

                        onVisibilityChange(".datepick-popup", (isVisible, _, selector) => {
                            // console.log('Selector:', selector, isVisible);
                            window.parent.postMessage({ type: 'popup', name: 'dates', isVisible }, '*');
                        });

                      });

                    </script>

                </html>
        `}
    ></Wrapper>
  );
};

export default BookingWidget;

const Wrapper = styled.iframe`
  /* width: 100vw; */
  /* height: 100%; */
  position: fixed;
  z-index: 100;
  bottom: 0px;
  left: 0px;
  border: none;
  width: 100%;
`;
